import { Injectable } from '@angular/core';
import { MatLegacyDialog } from "@angular/material/legacy-dialog";
import { UserWorkingHoursExportParameter } from "../../../_core/classes/user-working-hours-export.parameter";
import { DataRequest, MethodEnum } from "@ctsolution/ct-webapi";
import { FileService } from "../../../_core/lib/file.service";
import { environment } from "../../../../environments/environment";
import { UserWorkingHoursExportComponent } from "./user-working-hours-export/user-working-hours-export.component";
import { CtManagerService } from '../../../_core/lib/ct-manager.service';

@Injectable()
export class UserWorkingHoursExportService {

  constructor(
    private matLegacyDialog: MatLegacyDialog,
    private fileService: FileService,
    private managerService: CtManagerService) {
  }

  openDialog() {

    this.matLegacyDialog
      .open(UserWorkingHoursExportComponent, { disableClose: true });

  }

  async exportExcel(parameter: UserWorkingHoursExportParameter, exportName = `${environment.projectName}_WorkingHoursReport`) {

    await this.managerService.getComponentOverride("excel", "exportExcelConfiguration", parameter).then((component) => {
      return;
    });

    const request: DataRequest = new DataRequest()
      .setController(["UserWorkingHours"])
      .setAction('ExportExcelWorkedHours')
      .setBody(parameter)
      .setMethod(MethodEnum.POST);

    this.fileService
      .getFile(request)
      .subscribe(result => {

        this.fileService.blobDownload(result, exportName)

        return result;

      })

  }


}
